import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getRoles(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Role/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}